export default __webpack_public_path__ + "static/media/woodworking.7d8cdde7.png";